import { lazy } from 'react';

// Layouts
import EmptyLayout from 'layouts/EmptyLayout';

// Containers
import InstitutionGuard from '../InstitutionGuard';

// Public entries (no panel chrome) — mounted directly by ./index.js
export const institutionRegisterRoute = {
  exact: true,
  path: '/institutions/register',
  layout: EmptyLayout,
  component: lazy(() => import('pages/institutions/InstitutionRegistrationPage')),
};

export const institutionChooseRoute = {
  path: '/institutions',
  layout: EmptyLayout,
  guard: InstitutionGuard,
  component: lazy(() => import('pages/institutions/InstitutionChoosePage')),
};

// Panel children — mounted under the shared AppLayout route by ./index.js
export const institutionPanelRoutes = [
  // Account
  {
    exact: true,
    path: '/institutions/:institutionSlug',
    component: lazy(() => import('pages/institutions/InstitutionHomePage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/profile',
    component: lazy(() => import('pages/institutions/InstitutionProfilePage')),
  },
  // Eskolare Insights
  {
    exact: true,
    path: '/institutions/:institutionSlug/indicators/general',
    component: lazy(() => import('pages/institutions/InstitutionIndicatorsGeneralPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/indicators/sales-agreement',
    component: lazy(() => import('pages/institutions/InstitutionIndicatorsSalesAgreementPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/nps-score',
    component: lazy(() => import('pages/institutions/InstitutionNpsScorePage')),
  },
  // Management
  {
    exact: true,
    path: '/institutions/:institutionSlug/orders/:orderNumber',
    component: lazy(() => import('pages/institutions/InstitutionOrderDetailsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/orders',
    component: lazy(() => import('pages/institutions/InstitutionOrderPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/institution-shipment/:shipmentCode',
    component: lazy(() => import('pages/institutions/InstitutionShipmentDetailsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/institution-shipment',
    component: lazy(() => import('pages/institutions/InstitutionShipmentPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/b2b-purchase-portal/:salesAgreementCode',
    component: lazy(() => import('pages/institutions/InstitutionB2bPurchasePortalDetailsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/b2b-purchase-portal',
    component: lazy(() => import('pages/institutions/InstitutionB2bPurchasePortalPage')),
  },
  // Suppport
  {
    exact: true,
    path: '/institutions/:institutionSlug/support/platform-tickets/:platformTicketId',
    component: lazy(() => import('pages/institutions/InstitutionSupportPlatformTicketDetailsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/support/platform-tickets',
    component: lazy(() => import('pages/institutions/InstitutionSupportPlatformTicketsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/support/tickets/:ticketId',
    component: lazy(() => import('pages/institutions/InstitutionSupportTicketDetailsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/support/tickets',
    component: lazy(() => import('pages/institutions/InstitutionSupportTicketPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/support/platform-articles/:platformArticleSlug',
    component: lazy(() =>
      import('pages/institutions/InstitutionSupportPlatformArticleDetailsPage'),
    ),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/support/platform-articles',
    component: lazy(() => import('pages/institutions/InstitutionSupportPlatformArticlesPage')),
  },
  // Relationship
  {
    exact: true,
    path: '/institutions/:institutionSlug/partnerships',
    component: lazy(() => import('pages/institutions/InstitutionPartnershipPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/enrollments/requests',
    component: lazy(() => import('pages/institutions/InstitutionEnrollmentRequestPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/enrollments',
    component: lazy(() => import('pages/institutions/InstitutionEnrollmentPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/product-alerts',
    component: lazy(() => import('pages/institutions/InstitutionProductAlertPage')),
  },
  // Others
  {
    exact: true,
    path: '/institutions/:institutionSlug/school-census',
    component: lazy(() => import('pages/institutions/InstitutionSchoolCensusPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/sell-more',
    component: lazy(() => import('pages/institutions/InstitutionSellMorePage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/points',
    component: lazy(() => import('pages/institutions/InstitutionPointsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/points/catalog-items',
    component: lazy(() => import('pages/institutions/InstitutionPointsCatalogItemsPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/points/partner-referral',
    component: lazy(() => import('pages/institutions/InstitutionPointsPartnerReferralPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/points/regulations',
    component: lazy(() => import('pages/institutions/InstitutionPointsRegulationPage')),
  },
  {
    exact: true,
    path: '/institutions/:institutionSlug/points/rules',
    component: lazy(() => import('pages/institutions/InstitutionPointsRulesPage')),
  },
];
